import { ContentModules } from '@/utils/enums/ContentModules'

export function useActionBarScroll({
  contentModules,
  actionBarConfig,
  threshold = 0.1,
  jobData
}: {
  contentModules: ContentModule[]
  actionBarConfig?: ActionBarConfig
  threshold?: number
  jobData?: FlatJob
}) {
  const showActionBar = ref(false)
  let scrollListener: (() => void) | null = null

  // Check if we have a Hero module
  const hasHeroModule = computed(() => {
    return contentModules.some(module => module.component === ContentModules.HERO)
  })

  // Check if ActionBar should be shown
  const shouldShowActionBar = computed(() => {
    return hasHeroModule.value && !!actionBarConfig?.config?.general?.visibility
  })

  function setupScrollListener() {
    if (process.client) {
      scrollListener = () => {
        const scrollPosition = window.scrollY / (document.body.scrollHeight - window.innerHeight)
        showActionBar.value = scrollPosition > threshold
      }

      window.addEventListener('scroll', scrollListener)
    }
  }

  function removeScrollListener() {
    if (process.client && scrollListener) {
      window.removeEventListener('scroll', scrollListener)
      scrollListener = null
    }
  }

  onMounted(() => {
    if (shouldShowActionBar.value) {
      setupScrollListener()
    }
  })

  onUnmounted(() => {
    removeScrollListener()
  })

  // Function to add pitchYouButton configuration to modules
  const getModuleWithPitchYouButton = (module: ContentModule) => {
    const moduleClone = JSON.parse(JSON.stringify(module || {}))

    const { t } = useI18n()

    // Only add pitchYouButton config if jobData.pitch_you_url is set
    if (moduleClone && moduleClone.config && jobData && jobData.pitch_you_url) {
      if (moduleClone.config.applyButton) {
        moduleClone.config.pitchYouButton = {
          ...moduleClone.config.applyButton,
          useCustomColor: false,
          text: t("module.pitchYouButton-text")
        }
      } else {
        moduleClone.config.pitchYouButton = {
          useCustomColor: false,
          text: t("module.pitchYouButton-text")
        }
      }
    }

    return moduleClone
  }

  return {
    showActionBar,
    hasHeroModule,
    shouldShowActionBar,
    getModuleWithPitchYouButton
  }
}
